import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import {AtriumInfo, CustomerFavoriteItemDTO} from '../models/customer.model';
import {OrderApiService} from './order.api.service';
import {map} from 'rxjs/operators';
import {dataToAtriumInfo} from '../dto/customer.dto';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  public _atriumInfo: BehaviorSubject<AtriumInfo> = new BehaviorSubject<AtriumInfo>(new AtriumInfo());
  private apiUrl = `${environment.apiUrl}customers`;

  constructor(
    private http: HttpClient,
    private httpService: OrderApiService
  ) {}

  public set atriumInfo(atriumInfo: AtriumInfo) {
    this._atriumInfo.next(atriumInfo);
  }

  public get atriumInfo(): AtriumInfo {
    return this._atriumInfo.getValue();
  }

  public get atriumInfo$(): Observable<AtriumInfo> {
    return this._atriumInfo.asObservable();
  }

  public saveCustomerFavoriteItem(customerId: string, favoriteItem: CustomerFavoriteItemDTO): Observable<void> {
    const url = `${this.apiUrl}/${customerId}/favorite-item`;
    return this.http.post<void>(url, favoriteItem);
  }

  public deleteCustomerFavoriteItem(customerId: string, itemId: string): Observable<void> {
    const url = `${this.apiUrl}/${customerId}/favorite-item/${itemId}`;
    return this.http.delete<void>(url);
  }

  public getCustomerFavoriteItems(customerId: string): Observable<string[]> {
    const url = `${this.apiUrl}/${customerId}/favorite-items`;
    return this.http.get<string[]>(url);
  }

  public getAtriumInfo(orderBotUserId: string, bodyInfo: object): Observable<AtriumInfo> {
    return this.httpService.post(`customers/${orderBotUserId}/atrium`, bodyInfo)
      .pipe(
        map(response => {
          const info = dataToAtriumInfo(response);
          this.atriumInfo = info;
          return info;
        })
      );
  }

  public saveAtriumInfo(orderBotUserId: string, bodyInfo: object): Observable<AtriumInfo> {
    return this.httpService.post(`customers/${orderBotUserId}/atrium/campusid`, bodyInfo)
      .pipe(
        map(response => {
          const info = dataToAtriumInfo(response);
          this.atriumInfo = info;
          return info;
        })
      );
  }

  public deleteAtriumInfo(orderBotUserId: string, info: object): Observable<any> {
    return this.http.request(
      'DELETE',
      `${environment.apiUrl}customers/${orderBotUserId}/atrium`,
      {
        body: info,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
}
